var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8049 6.00998C27.1678 6.64547 29.3222 7.89065 31.0523 9.6208C32.7825 11.351 34.0276 13.5053 34.6631 15.8682",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3625 11.3969C24.7799 11.7782 26.0723 12.5252 27.1102 13.5631C28.148 14.601 28.895 15.8933 29.2763 17.3107",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1432 20.7868C14.5885 23.7427 16.9841 26.128 19.9462 27.5606C20.1631 27.6633 20.403 27.7077 20.6423 27.6894C20.8816 27.6711 21.112 27.5906 21.3107 27.456L25.6733 24.5486C25.8659 24.42 26.0877 24.3414 26.3184 24.32C26.5491 24.2985 26.7815 24.335 26.9946 24.426L35.1551 27.9243C35.4323 28.0421 35.6638 28.2467 35.8146 28.5074C35.9654 28.7681 36.0275 29.0707 35.9914 29.3697C35.7331 31.3878 34.7481 33.2427 33.2209 34.587C31.6937 35.9313 29.7288 36.6729 27.6942 36.6731C21.4101 36.6731 15.3834 34.1767 10.9399 29.7332C6.49635 25.2897 4 19.263 4 12.9789C4.00019 10.9444 4.74188 8.97977 6.08622 7.45277C7.43056 5.92576 9.28537 4.94109 11.3034 4.68309C11.6024 4.64704 11.905 4.70909 12.1657 4.85992C12.4264 5.01074 12.631 5.24217 12.7487 5.51936L16.2499 13.6869C16.34 13.8979 16.3765 14.1279 16.3563 14.3565C16.3362 14.585 16.2599 14.8051 16.1342 14.9971L13.2352 19.4265C13.1036 19.6259 13.026 19.8561 13.0098 20.0945C12.9937 20.3329 13.0397 20.5714 13.1432 20.7868V20.7868Z",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/phone1.7ef3498e2cfef6150b9cd7d8cd1b416b.svg";
export { ForwardRef as ReactComponent };